var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-range-picker',_vm._b({attrs:{"label":"Select Date Range","value":_vm.range,"format":"MMM Do YYYY","clearable":"","flat":"","filled":"","dense":""},on:{"input":_vm.selectRange,"clear":_vm.clear}},'date-range-picker',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }